import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import classNames from "classnames";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import {
  Button,
  Container,
  Input,
  Row,
  Label,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonGroup,
  Alert,
} from "reactstrap";
import { createPortal } from 'react-dom';
import { useParams, useHistory } from "react-router-dom";
import Select from "react-select";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { CheckCircle, Check, Copy } from "react-feather";
import "react-datepicker/dist/react-datepicker.css";

import {
  getCheck,
  getInvoice,
  getStatuses,
  getUpd,
  sendToDiadoc,
  updateOrder,
  baseUrl,
  setStatus,
  createReserve,
  carryOutOrder,
  addBonus,
  updateComment,
  sendTo1S,
  getAccounts,
  getTorg1T,
  copyOrder,
  printLabel
} from "services/api";
import { MySpinner } from "components/MySpinner";
import { Status } from "components/Status";
import {
  dateFormat,
  dateTimeFormat,
  priceFormat,
} from "utils/format";
import { useOrders } from "features/Orders/OrdersContext";
import { SelectCustomer } from "features/Dashboard/SelectCustomer";
import { SendInvoiceModal } from "features/Orders/SendInvoiceModal";
import { LabelModal } from "features/Orders/LabelModal";
import { ChangeLogOrders } from "features/Orders/ChangeLogOrders";
import { OrderProductTable } from "features/Orders/OrderProductTable";
import { HeaderPage } from "components/HeaderPage";
import { Checkbox } from "components/Checkbox";
import { useUser } from "features/Users/UserContext";
import { DeliveryBlock } from "features/Orders/DeliveryBlock";
import { SendUtdModal } from "features/Orders/SendUtdModal";
import { PrintUtd } from "features/Orders/PrintUtd";
import { PrintInvoice } from "features/Orders/PrintInvoice";
import { PrintLabel } from "features/Orders/PrintLabel";
import { PrintAssemblyList } from "features/Orders/PrintAssemblyList";

import "./orderOne.scss";
import { PrintTitle } from "features/Orders/PrintTitle";
import Barcode from "react-barcode";
import { getOrder1 } from "services/apiOrders";

registerLocale("ru", ru);

export const PAYMENTS = [
  { label: "Нал", value: 1 },
  { label: "Безнал", value: 2 },
  { label: "Терминал", value: 3 },
];

export const TRANSPORT_COMPANY = [
  { label: "Деловые линии", value: "Деловые линии" },
  { label: "Байкал", value: "Байкал" },
  { label: "СДЭК", value: "СДЭК" },
  { label: "УТС", value: "УТС" },
  { label: "ПЭК", value: "ПЭК" },
  { label: "КИТ", value: "КИТ" },
  { label: "БСД", value: "БСД" },
  { label: "ЦАП", value: "ЦАП" },
  { label: "НОРД ВИЛ", value: "НОРД ВИЛ" },
  { label: "Уральский Меридиан", value: "Уральский Меридиан" },
  { label: "ТЛК Альтернатива", value: "ТЛК Альтернатива" },
  { label: "ТК Мейджик Транс", value: "ТК Мейджик Транс" },
  { label: "Другая ТК", value: "Другая ТК" },
  { label: "Желдорэкспедиция", value: "Желдорэкспедиция" },
  { label: "Энергия", value: "Энергия" },
  { label: "СДС-Карго", value: "СДС-Карго" },
  { label: "ТК Мир", value: "ТК Мир" }
];

export const OrderOnePage = () => {
  const { id } = useParams();
  const history = useHistory();
  const { setStatuses, status, setLoading, loading, setProducts, products, productsWithDetails } =
    useOrders();
  const { user, admins } = useUser();
  const [order, setOrder] = useState({});
  const [comment, setComment] = useState("");
  const [customer, setCustomer] = useState(null);
  const [account, setAccount] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [shippingDate, setShippingDate] = useState("");
  const [admin, setAdmin] = useState(null);
  const [sklad, setSklad] = useState(null);
  const [contract, setContract] = useState(null);
  const [contracts, setContracts] = useState([]);
  const [date, setDate] = useState("");
  const [regulated, setRegulated] = useState(true);
  const [bonus, setBonus] = useState(0);
  const [openModalLabel, setOpenModalLabel] = useState(false);
  const [quantityLabels, setQuantityLabels] = useState(0);
  const [quantityPallets, setQuantityPallets] = useState(0);
  const [noEdit, setNoEdit] = useState(false);
  const [error, setError] = useState("");
  const [priceNds, setPriceNds] = useState(false);
  const [storeKeeper, setStoreKeeper] = useState(null);
  const [payment, setPayment] = useState("");
  const [showPrintInvoice, setShowPrintInvoice] = useState(false);
  const [showPrintUtd, setShowPrintUtd] = useState(false);
  const [showPrintLabels, setShowPrintLabels] = useState(false);
  const [showPrintAssembliList, setShowPrintAssembliList] = useState(false);
  const [utd, setUtd] = useState(null);
  const [base, setBase] = useState(null);
  const [payd, setPayd] = useState(false);
  const [inventoryRefreshKey, setInventoryRefreshKey] = useState(0);

  const getAndSetStatuses = () => {
    getStatuses()
      .then((res) => {
        setStatuses(res);
      })
      .catch((e) => toast.error(e?.response?.data?.message));
  };

  const getAndSetOrder = () => {
    getOrder1(id)
      .then((res) => {
        setOrder(res);
      })
      .catch((e) => toast.error(e?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    getAndSetStatuses();
    return () => setProducts([]);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPayment(order.payment?.id);
    setComment(order.comment || "");
    setCustomer({ value: order.customer?.id, label: order.customer?.name });

    setAccount({ value: order.account?.id, label: order.account?.name });

    if (order.admin) {
      setAdmin({ value: order.admin?.id, label: order.admin?.name });
    }

    setContracts(
      order.customer?.contracts.map((val) => {
        return {
          label: val.label,
          value: val.id,
        };
      })
    );

    setContract(order.contract ? { value: order.contract?.id, label: order.contract?.name } : null);

    setDate(dateFormat(order.date));
    setShippingDate(dateTimeFormat(order.shippingDate));
    setRegulated(order.regulated);
    setBonus(order.bonus || "");
    setPriceNds(order.priceNds || false);
    if (order.storeKeeper) {
      setStoreKeeper({
        value: order.storeKeeper?.id,
        label: order.storeKeeper?.name,
      });
    }

    if (order?.account) {
      setAccount({ value: order?.account?.id, label: order?.account?.title || "Главное подразделение" });
    }

    getAndSetAccounts(order?.customer?.id);

    setQuantityLabels(order?.settings?.quantityLabels);
    setQuantityPallets(order?.settings?.quantityPallets);
    setBase(order?.settings?.base);
    setPayd(order?.payd);
    // if (order.carriedOut) {
    setLoading(true);
    getUpd({ id, json: true })
      .then(setUtd)
      .finally(() => {
        // setLoading(false);
      });
    //  }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order]);

  useEffect(() => {
    getAndSetOrder();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const orderHandler = (address = null) => {
    if (!order.id) return;
    setLoading(true);
    updateOrder({
      id: order.id,
      comment,
      admin: admin?.value,
      storeKeeper: storeKeeper?.value,
      date,
      shippingDate,
      sklad: sklad?.value,
      contract: contract?.value,
      regulated,
      bonus: parseInt(bonus),
      priceNds,
    })
      .then((res) => {
        setOrder(res);
        toast.success("Данные заказа успешно сохранены");
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const selectHandler = (val, res) => {
    switch (res.name) {
      case "admin":
        setAdmin(val);
        break;
      case "storeKeeper":
        setStoreKeeper(val);
        break;
      case "sklad":
        setSklad(val);
        break;
      case "contract":
        setContract(val);

        setLoading(true);
        updateOrder({
          id: order.id,
          contract: val?.value
        })
          .then((res) => {
            setOrder(res);
            toast.success("Договор успешно сохранен");
          })
          .catch((e) => toast.error(e.response?.data?.message))
          .finally(() => setLoading(false));
        break;
      default:
        break;
    }
  };

  const changeHandler = (e) => {
    switch (e.target.name) {
      case "comment":
        setComment(e.target.value);
        break;
      case "bonus":
        setBonus(e.target.value);
        break;
      case "date":
        setDate(e.target.value);
        break;
      case "shippingDate":
        setShippingDate(e.target.value);
        break;
      default:
        break;
    }
  };

  const diadocHandler = () => {
    if (!id) return;

    setLoading(true);
    sendToDiadoc({
      id
    })
      .then((res) => {
        toast.success("Документ отправлен в диадок");
        setOrder(res);
      })
      .catch((e) => {
        if (e.response?.data?.message) {
          setError(e.response?.data?.message);
        } else {
          setError("Ошибка при отправке в диадок");
        }
      })
      .finally(() => setLoading(false));
  };

  const updHandler = () => {
    getUpd({ id })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `УПД № ${order.number} от ${order.shippingDateText}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getTorg1THandler = () => {
    getTorg1T({ id })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `ТТН № ${order.number} от ${order.shippingDateText}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const invoiceHandler = (withSign = false) => {
    getInvoice({
      id,
      withSign: withSign ? 1 : 0,
    })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Счет № ${order.number}.xlsx`);
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const checkHandler = () => {
    getCheck({ id })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Чек № ${order.number}.xlsx`);
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const validProvider = () => {
    return products.find((val) => !val.provider);
  };

  const setBonusHandler = () => {
    setLoading(true);
    addBonus({
      id,
      bonus,
    })
      .then((res) => {
        setOrder(res);
        toast.success("Бонус успешно сохранен");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const setCommentHandler = () => {
    setLoading(true);
    updateComment({
      id,
      comment
    })
      .then((res) => {
        setOrder(res);
        toast.success("Комментарий успешно сохранен");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const setBaseHandler = () => {
    setLoading(true);
    updateOrder({
      id,
      base
    })
      .then((res) => {
        setOrder(res);
        toast.success("Основание успешно сохранено");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const paymentHandler = (payment) => {
    if (payment?.value === 2) {
      toast.error("нельзя выбрать безнал");
      return;
    }
    setLoading(true);
    updateOrder({
      id: order.id,
      payment: payment?.value,
    })
      .then((res) => {
        setOrder(res);
        toast.success("Способ оплаты успешно сохранен");
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (order.status?.sort >= 4) {
      setNoEdit(true);
    } else {
      setNoEdit(false);
    }
  }, [order.status]);

  const accountsMap = (res) =>
    res.map((item) => {
      return { value: item.id, label: item.title || "Главное подразделение" };
    });

  const getAndSetAccounts = (customerId = null) => {
    getAccounts(customerId || customer?.value)
      .then((res) => {
        if (res.length < 2) return;
        setAccounts(accountsMap(res));
        if (!customerId) {
          setAccount({ value: res[0].id, label: res[0].title || "Главное подразделение" });
        }

      });
  };

  const customerHandler = (val) => {
    setCustomer(val);
    setLoading(true);

    updateOrder({
      id: order.id,
      customer: val?.value,
    })
      .then((res) => {
        setOrder(res);
        toast.success("Клиент успешно изменен");
        getAndSetAccounts();
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => setLoading(false));

  };

  const acccountHandler = (val) => {
    setAccount(val);
    setLoading(true);

    updateOrder({
      id: order.id,
      account: val?.value,
    })
      .then((res) => {
        setOrder(res);
        toast.success("Подразделение успешно изменено");
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const statusHandler = (status) => {
    console.log(order);
    setLoading(true);
    setStatus({
      orderId: order?.id,
      statusId: status?.id,
    })
      .then(() => {
        getAndSetOrder();
        toast.success("Статус успешно изменен");
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  const reserveHandler = () => {
    setLoading(true);
    createReserve({
      id,
    })
      .then(() => {
        getAndSetOrder();
        toast.success("Товар успешно зарезервирован");
      })
      .catch((e) => {
        toast.error(e.response.data.message);
      })
      .finally(() => setLoading(false));
  };

  const copyHandler = () => {
    setLoading(true);
    copyOrder({
      id
    })
      .then((res) => {
        history.push(res.id);
        setOrder(res);
        toast.success("Заказ успешно скопирован");
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  const carryOutHandler = () => {
    if (!order.carriedOut) {
      for (const row of products) {


        if (row.provider?.id === "518680fd-6d10-4543-96a4-108534ba69ca") {
          continue;
        }

        const providersBatch = row.providersBatch?.find(
          (val) => val.id === row.provider?.id
        );

        if (row.providersBatch?.length > 0 && !providersBatch) {
          toast.error("Не все поставщики проставлены правильно");
          return;
        }

        if (row.warehouse?.branch !== 0 && user?.branch !== row.warehouse?.branch) {
          toast.error("Попытка списания со склада из другого филиала");
          return;
        }
      }
    }

    if (!order.storeKeeper) {
      toast.error("Нужно выбрать сборщика");
      return;
    }

    setLoading(true);
    carryOutOrder({
      id,
      carryOut: order.carriedOut ? 0 : 1,
      shippingDate,
    })
      .then((res) => {
        if (res.carriedOut) {
          toast.success("Заказ успешно проведен");
          if (
            (res.customer?.toSendDiadoc?.find(v => v === 'automaticSend')
              || !res.customer?.toSendDiadoc
            )
            && !res.ourBranch
            && !res.sentToDiadoc) {
            diadocHandler();
          } else {
            getAndSetOrder();
          }
        } else {
          toast.success("Заказ успешно распроведен");
          getAndSetOrder();
          setInventoryRefreshKey((v) => v + 1);
        }

      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
        setLoading(false);
        getAndSetOrder();
      });
  };

  const storeKeeperHandler = (storeKeeper) => {
    setLoading(true);
    setStoreKeeper(storeKeeper);
    updateOrder({
      id: order.id,
      storeKeeper: storeKeeper?.value,
    })
      .then((res) => {
        setOrder(res);
        toast.success("Сборщик успешно установлен");
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const regulatedHandler = (regulated) => {
    setLoading(true);
    setRegulated(regulated);
    updateOrder({
      id: order.id,
      regulated,
    })
      .then((res) => {
        setOrder(res);
        toast.success("Регл. учет успешно сохранен");
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const paydHandler = (payd) => {
    setLoading(true);
    setPayd(payd);
    updateOrder({
      id: order.id,
      payd,
    })
      .then((res) => {
        setOrder(res);
        toast.success("Статус оплаты успешно сохранен");
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const printHandler = () => {

    if (order.printDoc.find(v => v === "invoice") || !order.printDoc.length) {

      getInvoice({
        id: order.id,
        withSign: 1,
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Счет № ${order.number}.xlsx`);
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          setLoading(false);
        });
    }

    if (order.printDoc.find(v => v === "utd") || !order.printDoc.length) {
      getUpd({ id: order.id })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `УПД № ${order.number} от ${order.shippingDateText}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          setLoading(false);
        });
    }

    if (order.printDoc.find(v => v === "torg1T") || !order.printDoc.length) {
      getTorg1T({ id: order.id })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `ТТН № ${order.number} от ${order.shippingDateText}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          setLoading(false);
        });
    }

    setOpenModalLabel(true);
  };

  useEffect(() => {

    if (showPrintInvoice) {
      window.print();
      setTimeout(() => {
        setShowPrintInvoice(false);
        setShowPrintUtd(true);
      }, 200);
    }

    if (utd && showPrintUtd) {
      setTimeout(() => {
        window.print();
      }, 200);
      setTimeout(() => {
        setShowPrintUtd(false);
      }, 200);
    }

  }, [showPrintUtd, showPrintInvoice, showPrintLabels]);

  const print1 = () => {
    setOpenModalLabel(true);
  }

  const printLabelOnPallet = () => {
    printLabel({ id })
      .then((res) => {
        toast.success("Стикер отправлен на принтер");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <>
      {createPortal(
        <>
          <>
            {showPrintUtd && utd && order.carriedOut &&
              <>
                <PrintUtd utd={utd} />
                <div className="pageBreakBefore" />
                <PrintUtd utd={utd} />
              </>
            }
          </>
          <>
            {showPrintLabels && utd &&
              <PrintLabel
                order={order}
                utd={utd}
                quantityLabels={quantityLabels}
                setShowPrintLabels={setShowPrintLabels}
              />
            }
          </>
          <>
            {showPrintInvoice && utd &&
              <>
                <PrintTitle order={order} utd={utd} quantityLabels={quantityLabels} />
                <div className="pageBreakBefore" />
                <PrintInvoice utd={utd} />
              </>
            }
          </>
          <>
            {showPrintAssembliList &&
              <>
                <PrintAssemblyList
                  order={order}
                  setShowPrintAssembliList={setShowPrintAssembliList}
                  setLoading={setLoading}
                  callback={setOrder}
                  products={productsWithDetails}
                />
              </>
            }
          </>

        </>,
        document.body
      )}

      <Container fluid className="p-0 order">
        <Helmet>
          <title>
            Заказ №{`${order.number || ""} от ${order.customer?.name}`}
          </title>
        </Helmet>

        <HeaderPage title={`Заказ № ${order.number}`}>
          <>
            <div className="order__date-block">
              <Label>Дата</Label>
              <ButtonGroup>
                <InputMask
                  id="date"
                  name="date"
                  type="text"
                  onChange={changeHandler}
                  value={date}
                  mask={"99.99.9999"}
                  className="form-control date"
                />
                <ChangeLogOrders id={id} />
              </ButtonGroup>
            </div>

            {(order.status?.sort === 5 || order.status?.sort === 6) && (
              <div className="order__carried-out-button">
                <div className="order__date-block shipping-date">
                  <Label>Дата реализации</Label>
                  <InputMask
                    id="shippingDate"
                    name="shippingDate"
                    type="text"
                    onChange={changeHandler}
                    value={shippingDate}
                    mask={"99.99.9999 99:99:99"}
                    className="form-control date"
                  />
                </div>
              </div>
            )}

            <Barcode height={40} fontSize={20} value={`O${order?.number}`} format="CODE128" displayValue={false} className="ml-2" />
          </>
        </HeaderPage>

        {order?.customer?.remainingDebtExpired !== 0 && (
          <div className="order__debt-warning">
            <div className="order__debt-warning-title">Внимание! У клиента есть просроченная задолженность!</div>
            <div className="mb-1 debt-warning">При просрочке более 3 дней - отгрузка блокируется.</div>
            <div className="order__debt-warning-amount">
              Просроченная задолженность: <b>{priceFormat(order?.customer?.remainingDebtExpired)} р.</b>
            </div>
          </div>
        )}

        {loading && <MySpinner overlay />}

        {error && <Alert color="danger">{error}</Alert>}

        <Row className="elem">
          <div className="elem-field customer">
            <Label>Клиент</Label>
            <SelectCustomer customer={customer} setCustomer={customerHandler} />
          </div>
          {accounts.length > 1 &&
            <div className="elem-field">
              <Label>Подразделение</Label>
              <Select
                name="account"
                placeholder="Подразделение"
                className="react-select-container"
                classNamePrefix="react-select"
                options={accounts}
                value={account}
                onChange={acccountHandler}
              />

            </div>
          }
          <div>
            <div className="d-flex">
              <div className="balance">

                <div>
                  Баланс клиента:{" "}
                  <b
                    className={classNames({
                      red: order.customer?.balance < 0,
                      green: order.customer?.balance > 0,
                    })}
                  >
                    {priceFormat(order.customer?.balance)} р
                  </b>
                </div>

                {order?.customer?.remainingDebtExpired !== 0 &&
                  <div className="order__debt-expired">
                    Проср. задолжен.:{" "}
                    <b className="red">
                      {priceFormat(order.customer?.remainingDebtExpired)} р
                    </b>
                  </div>
                }

              </div>

              <div className="payd">
                <Label>Оплачено</Label>
                <Checkbox
                  name="payd"
                  value="payd"
                  checked={payd}
                  onChange={(e) => paydHandler(e.target.checked)}
                />
              </div>
            </div>
          </div>
        </Row>
        <Row className="elem">
          <div className="elem-field">
            <Label>Ответственный менеджер</Label>
            <Select
              name="admin"
              placeholder="Ответственный менеджер"
              className="react-select-container"
              classNamePrefix="react-select"
              options={admins}
              value={admin}
              onChange={selectHandler}
            />
          </div>
          <div className="elem-field">
            <Label>Сборщик</Label>
            <Select
              name="storeKeeper"
              placeholder="Сборщик"
              className="react-select-container"
              classNamePrefix="react-select"
              options={admins.filter((item) => item.department === "warehouse")}
              value={storeKeeper}
              onChange={storeKeeperHandler}
            />
          </div>
          <div className="elem-field bonus">
            <Label>Бонус</Label>
            <ButtonGroup>
              <Input
                name="bonus"
                placeholder="Бонус"
                onChange={changeHandler}
                value={bonus}
              />
              <Button onClick={setBonusHandler}>
                <Check size={15} />
              </Button>
            </ButtonGroup>
          </div>
          {order.customer?.type === 2 && (
            <>
              <div className="elem-field reglam">
                <Label>Регл. учет</Label>
                <Checkbox
                  name="regulated"
                  value="regulated"
                  checked={regulated}
                  onChange={(e) => {
                    const isChecked = e.target.checked;

                    if (!isChecked) {
                      const confirmed = window.confirm(
                        "Если убрать галочку, то реализация не выгрузится в 1С!"
                      );
                      regulatedHandler(confirmed ? false : true);
                      return;
                    }

                    regulatedHandler(true);
                  }}
                />
              </div>
              <div className="elem-field withoutnds">
                <Label>Указать цену без НДС</Label>
                <Checkbox
                  name="priceNds"
                  value="priceNds"
                  checked={priceNds}
                  onChange={(e) => setPriceNds(e.target.checked)}
                />
              </div>
            </>
          )}
        </Row>

        <DeliveryBlock
          order={order}
          setOrder={setOrder}
          setLoading={setLoading}
          quantityLabels={quantityLabels}
          setQuantityLabels={setQuantityLabels}
          setQuantityPallets={setQuantityPallets}
          quantityPallets={quantityPallets}
        />

        <Row className="elem">
          {order?.customer?.type === 1 && (
            <div className="elem-field">
              <Label>Способ оплаты</Label>
              <Select
                name="payment"
                placeholder="Способ оплаты"
                className="react-select-container"
                classNamePrefix="react-select"
                options={PAYMENTS}
                value={PAYMENTS.find((val) => payment === val.value)}
                onChange={paymentHandler}
              />
            </div>
          )}

          <div className="elem-field contract">
            <Label>Договор</Label>
            <Select
              name="contract"
              placeholder="Договор"
              className="react-select-container"
              classNamePrefix="react-select"
              options={contracts}
              value={contract}
              onChange={selectHandler}
            />
          </div>

        </Row>
        <Row className="elem">
          <div className="elem-field base">
            <Label>Основание для УПД (если заполнено, заменяет договор)</Label>
            <div className="d-flex">
              <Input
                name="name"
                placeholder="Наименование"
                onChange={e => setBase(prev => ({ ...prev, name: e.target.value }))}
                value={base?.name}
                className="mr-1"
              />
              <Input
                name="number"
                placeholder="Номер"
                onChange={e => setBase(prev => ({ ...prev, number: e.target.value }))}
                value={base?.number}
                className="mr-1"
              />
              <InputMask
                name="date"
                type="text"
                onChange={e => setBase(prev => ({ ...prev, date: e.target.value }))}
                value={base?.date}
                mask={"99.99.9999"}
                className="form-control date"
              />
            </div>
            <Button onClick={setBaseHandler} color="primary" className="mt-1">
              Сохранить основание
            </Button>
          </div>
        </Row>
        <Row className="elem bottom">
          <div className="elem-field comment">
            <Label>Комментарий</Label>
            <Input
              type="textarea"
              name="comment"
              placeholder="Комментарий"
              onChange={changeHandler}
              value={comment}
            />
            <Button onClick={setCommentHandler} color="primary" className="mt-1">
              Сохранить комментарий
            </Button>
          </div>

          <div className="button-block">
            <SendInvoiceModal id={id} user={order.account} />

            {order.carriedOut &&
              <SendUtdModal id={id} order={order} user={order.account} />
            }

            {order.customer?.withDiadoc && order.carriedOut && (
              <Button
                color="primary"
                onClick={() => diadocHandler()}
                className="button-wide"
              >
                {order.sentToDiadoc && (
                  <CheckCircle color="green" className="sent-diadoc" />
                )}
                Выгрузить в Диадок
              </Button>
            )}

            {!noEdit && (
              <Button
                color="primary"
                onClick={reserveHandler}
                className="button-wide"
              >
                Резерв
              </Button>
            )}

            <UncontrolledButtonDropdown className="download">
              <DropdownToggle className="dropdown-toggle button-wide">
                Скачать
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => printHandler()}>
                  Пакет документов
                </DropdownItem>
                {order.customer?.type === 2 ? (
                  <>
                    <DropdownItem onClick={() => invoiceHandler(true)}>
                      Счет с печатью
                    </DropdownItem>
                    <DropdownItem onClick={() => invoiceHandler(false)}>
                      Счет без печати
                    </DropdownItem>
                  </>
                ) : (
                  <DropdownItem onClick={checkHandler}>Чек</DropdownItem>
                )}
                <DropdownItem onClick={() => {
                  setShowPrintAssembliList(true);
                }} >
                  Сборочную ведомость
                </DropdownItem>
                {order.carriedOut && (<>
                  <DropdownItem onClick={updHandler}>УПД</DropdownItem>
                  <DropdownItem onClick={getTorg1THandler}>ТТН</DropdownItem>
                </>
                )}

                <DropdownItem>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`${baseUrl}/orders.getOffer?id=${order.id}`}
                  >
                    Комм. предложение
                  </a>
                </DropdownItem>

                <DropdownItem onClick={() => {
                  setOpenModalLabel(true);
                }}>
                  Этикетки
                </DropdownItem>
                <DropdownItem onClick={() => printLabelOnPallet()}>
                  Стикер на паллет
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>

            <Button
              color="primary"
              onClick={copyHandler}
              className="ml-1"
            >
              <Copy />
            </Button>
          </div>


          <div className="button-block">
            <Status order={order} statusHandler={statusHandler}>
              {order.status?.name}
            </Status>
            <>{!noEdit && (
              <Button onClick={() => orderHandler()} color="primary button-wide">
                Сохранить
              </Button>
            )}</>
            <>{(order.status?.sort === 5 || order.status?.sort === 6 || order.status?.sort === 7) && (
              <Button
                color="primary"
                onClick={carryOutHandler}
                className="button-wide carryOut"
              >
                {order.carriedOut && <CheckCircle color="green" className="mr-1" />}
                {order.carriedOut ? `Распровести заказ` : `Провести заказ`}
              </Button>
            )}</>
            <>{user.branch === 1 && utd?.number && order.carriedOut &&
              <Button onClick={print1} color="primary button-wide">
                Печать
              </Button>
            }</>
          </div>

        </Row>

        <OrderProductTable
          order={order}
          noEdit={noEdit}
          inventoryRefreshKey={inventoryRefreshKey}
        />

        <LabelModal
          id={id}
          openModal={openModalLabel}
          setOpenModal={setOpenModalLabel}
          setQuantityLabels={setQuantityLabels}
          quantityLabels={quantityLabels}
          setQuantityPallets={setQuantityPallets}
          quantityPallets={quantityPallets}
          setShowPrintLabels={setShowPrintLabels}
          setShowPrintInvoice={setShowPrintInvoice}
          showPrintLabels={showPrintLabels}
        />
      </Container >


    </>
  );
};
